import { formatDateShort, formatTime } from '../lib/format.js';

const ZONE_FOR_AIRPORT = {
  PDX: 'America/Los_Angeles',
  SEA: 'America/Los_Angeles',
  JNU: 'America/Juneau',
};

export default function FlightCard({ leg }) {
  const departTz = ZONE_FOR_AIRPORT[leg.from] || undefined;
  const arriveTz = ZONE_FOR_AIRPORT[leg.to] || undefined;

  return (
    <div className="card px-4 py-3">
      <div className="flex items-center justify-between font-mono text-xs uppercase tracking-wider text-fg-tertiary">
        <span>
          {leg.airline} {leg.number}
        </span>
        <span>{formatDateShort(leg.depart, { timezone: departTz })}</span>
      </div>
      <div className="mt-2 flex items-center justify-between">
        <Endpoint code={leg.from} time={leg.depart} tz={departTz} />
        <span className="mx-2 flex-1 border-t border-dashed border-border-tertiary" />
        <Endpoint code={leg.to} time={leg.arrive} tz={arriveTz} align="right" />
      </div>
    </div>
  );
}

function Endpoint({ code, time, tz, align = 'left' }) {
  return (
    <div className={align === 'right' ? 'text-right' : ''}>
      <p className="font-mono text-lg font-medium tracking-wider">{code}</p>
      <p className="text-xs text-fg-secondary">{formatTime(time, { timezone: tz })}</p>
    </div>
  );
}
